import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Nav } from "./Nav";

export const LegalPage = ({ title, updated, children, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="grain bg-[#0B0B0C] text-[#F2F0EB] min-h-screen" data-testid={testId}>
      <Nav />

      <motion.main
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto max-w-3xl px-5 sm:px-8 pt-16 sm:pt-24 pb-24"
      >
        <p className="eyebrow mb-6" data-testid="legal-eyebrow">LEGAL</p>
        <h1
          className="h-heavy text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-6"
          data-testid="legal-title"
        >
          {title}
        </h1>
        <p className="text-sm text-[#6E7178] font-mono-brand tracking-widest mb-16" data-testid="legal-updated">
          LAST UPDATED · {updated}
        </p>

        <div className="legal-prose space-y-8 text-[#C6C4BE] text-[15px] sm:text-base leading-relaxed">
          {children}
        </div>

        <div className="mt-20 pt-10 border-t border-[#F2F0EB]/5 flex items-center justify-between">
          <Link
            to="/"
            className="text-xs sm:text-sm text-[#9DA1A8] hover:text-[#F2F0EB] transition-colors font-mono-brand tracking-widest"
            data-testid="legal-footer-home"
          >
            ← RETURN HOME
          </Link>
          <span className="text-xs text-[#6E7178] font-mono-brand tracking-widest">
            © 2026 SOURCECODED
          </span>
        </div>
      </motion.main>
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="text-[#F2F0EB] text-lg sm:text-xl font-medium mb-3 tracking-tight">
      {heading}
    </h2>
    <div className="space-y-4">{children}</div>
  </section>
);
